<!--
   Created by Claude on 2024
   选择作品组件
-->
<template>
  <div class="works-picker">
    <div class="picker-header">
      <div class="picker-title">选择例图</div>
      <div class="picker-close" @click="handleClose">
        <van-icon name="cross" />
      </div>
    </div>

    <div
      class="picker-tip"
      v-if="works.length > 0 && selectedList.length < max"
    >
      显示近 60 天内本人创作的作品，需选择 {{ max }} 个作品
    </div>
    <div
      class="picker-tip warning"
      v-else-if="works.length > 0 && works.length < max"
    >
      有作品但不足 {{ max }} 个，请先发布更多作品
    </div>

    <div class="picker-content" v-if="works.length > 0">
      <div
        class="work-item"
        v-for="work in works"
        :key="work.id"
        @click="handleSelect(work)"
      >
        <div class="checkbox-wrapper">
          <van-checkbox
            :model-value="isSelected(work)"
            :disabled="!isSelected(work) && selectedList.length >= max"
            icon-size="16px"
          />
        </div>
        <div class="work-info">
          <img
            class="work-cover"
            :src="work.cover + '!mfit_w100_h100_webp'"
            alt=""
          />
          <div class="work-detail">
            <div class="work-title">{{ work.name || "--" }}</div>
            <!-- <div class="work-type">
              <span class="type-tag">{{ work.type }}</span>
            </div> -->
          </div>
        </div>
      </div>
    </div>

    <DuEmpty v-else extClass="empty-state" text="暂无作品，请先发布作品" />

    <div class="picker-footer">
      <van-button
        class="confirm-btn"
        :class="{ disabled: selectedList.length !== max }"
        block
        @click="handleConfirm"
      >
        确定（{{ selectedList.length }}/{{ max }}）
      </van-button>
    </div>
  </div>
</template>

<script setup>
import { ref, watch, defineProps, defineEmits } from "vue";
import {
  Icon as VanIcon,
  Button as VanButton,
  Checkbox as VanCheckbox,
  showToast,
} from "vant";
import { DuEmpty } from "dangoui";

const props = defineProps({
  works: {
    type: Array,
    default: () => [],
  },
  selected: {
    type: Array,
    default: () => [],
  },
  max: {
    type: Number,
    default: 4,
  },
});

const emit = defineEmits(["confirm", "close"]);

const selectedList = ref([...props.selected]);

watch(
  () => props.selected,
  (val) => {
    selectedList.value = [...val];
  }
);

const isSelected = (work) => {
  return selectedList.value.some((w) => w.id === work.id);
};

const handleSelect = (work) => {
  const index = selectedList.value.findIndex((w) => w.id === work.id);
  if (index > -1) {
    selectedList.value.splice(index, 1);
  } else {
    if (selectedList.value.length >= props.max) {
      showToast(`最多只能选择 ${props.max} 个作品`);
      return;
    }
    selectedList.value.push(work);
  }
};

const handleConfirm = () => {
  if (selectedList.value.length !== props.max) {
    showToast(`请选择 ${props.max} 个作品`);
    return;
  }
  emit("confirm", selectedList.value);
};

const handleClose = () => {
  emit("close");
};
</script>

<style lang="scss" scoped>
.works-picker {
  display: flex;
  flex-direction: column;
  height: 100%;
  background-color: #fff;

  .picker-header {
    display: flex;
    align-items: center;
    justify-content: center;
    position: relative;
    padding: 32rpx 30rpx;

    .picker-title {
      font-size: 32rpx;
      font-weight: 500;
      color: #000;
    }

    .picker-close {
      position: absolute;
      right: 30rpx;
      top: 50%;
      transform: translateY(-50%);
      font-size: 40rpx;
      color: #000;
    }
  }

  .picker-tip {
    padding: 0 30rpx 16rpx;
    font-size: 24rpx;
    color: rgba(0, 0, 0, 0.4);

    &.warning {
      color: #ff6b00;
    }
  }

  .picker-content {
    flex: 1;
    overflow-y: auto;
    padding: 0 30rpx;

    .work-item {
      display: flex;
      align-items: center;
      padding: 16rpx 0;
      border-bottom: 1rpx solid rgba(0, 0, 0, 0.04);

      &:last-child {
        border-bottom: none;
      }

      .checkbox-wrapper {
        margin-right: 20rpx;
      }

      .work-info {
        display: flex;
        align-items: center;
        flex: 1;

        .work-cover {
          width: 100rpx;
          height: 100rpx;
          border-radius: 8rpx;
          object-fit: cover;
        }

        .work-detail {
          margin-left: 16rpx;
          flex: 1;

          .work-title {
            font-size: 28rpx;
            font-weight: 500;
            color: #000;
            line-height: 48rpx;
            overflow: hidden;
            text-overflow: ellipsis;
            white-space: nowrap;
          }

          .work-type {
            margin-top: 8rpx;

            .type-tag {
              display: inline-block;
              padding: 4rpx 8rpx;
              font-size: 24rpx;
              color: rgba(0, 0, 0, 0.6);
              background-color: rgba(0, 0, 0, 0.04);
              border-radius: 4rpx;
            }
          }
        }
      }
    }
  }

  .empty-state {
    flex: 1;
    display: flex;
    align-items: center;
    justify-content: center;
  }

  .picker-footer {
    padding: 16rpx 20rpx;
    padding-bottom: calc(16rpx + env(safe-area-inset-bottom));
    background-color: #fff;
    box-shadow: 0 -2rpx 8rpx rgba(0, 0, 0, 0.04);

    .confirm-btn {
      height: 96rpx;
      background: linear-gradient(180deg, #2b1ac0 0%, #7247dc 100%);
      border-radius: 12rpx;
      border: none;
      font-size: 32rpx;
      font-weight: 500;
      color: #fff;

      &.disabled {
        background: linear-gradient(
          180deg,
          rgba(43, 26, 192, 0.3) 0%,
          rgba(114, 71, 220, 0.3) 100%
        );
      }
    }
  }
}
</style>
